import { Button, Icon, Paragraph, Spacing, Title } from "@sicredi/react";
import styles from "./styles.module.scss";
import { handleGoAppStorePropostaAceita } from "#/contextProver/ContextProverServices";
import { useNavigate } from "react-router-dom";
import { PAGE } from "#/constants";
import { useContext } from "react";
import { ContextAPI } from "#/contextProver/ContextProver";

export const PropostaAceita: React.FC = () => {
  const { isMobile } = useContext(ContextAPI);
  const navigate = useNavigate();

  const userAgent = navigator.userAgent;
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/);
  const isAndroid = /android/i.test(userAgent);

  const handleButtonWeb = () => {
    navigate(PAGE.ROOT);
  };

  const handleButtonMobile = () => {
    navigate(PAGE.ROOT);
    setTimeout(() => {
      handleGoAppStorePropostaAceita();
    }, 500);
  };

  return (
    <div className={styles.container}>
      <Spacing appearance="large" />
      <Icon name="clock" size={104} color="#3FA110" />
      <Spacing appearance="medium" />

      <Title as="h2">Acesse o aplicativo do Sicredi!</Title>
      <Spacing appearance="small" />

      <Paragraph className={styles.paragraph}>
        Seu contrato está disponível para assinatura no aplicativo do Sicredi.
        Acesse o campo mensagens e conclua esta etapa.
      </Paragraph>
      <Spacing appearance="large" />

      {isMobile && (iOS || isAndroid) && (
        <Button
          className={styles.button}
          onClick={handleButtonMobile}
          appearance="primary"
          block={true}
        >
          Ir para o aplicativo do Sicredi
        </Button>
      )}
      {(isMobile || !isMobile) && !iOS && !isAndroid && (
        <Button
          className={styles.button}
          onClick={handleButtonWeb}
          appearance="primary"
          block={true}
        >
          Voltar para a tela inicial
        </Button>
      )}
    </div>
  );
};
